import { ReactNode, isValidElement } from 'react'

import { Box, List, Text } from '@factorialco/deprecated-design-system'
import { ContractsTaxonomiesDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import ContractData from 'modules/contracts/components/ContractDetails/Section/ContractData'
import type Compensation from 'modules/contracts/store/models/Compensation'
import type Employee from 'modules/employees/store/models/Employee'

import CompensationItem from './CompensationItem'

interface Props {
  compensations: Compensation[]
  employee: Employee
  additionalCompensationsList: ReactNode
}

const AdditionalCompensations = ({
  compensations,
  employee,
  additionalCompensationsList,
}: Props) => {
  const hasCompensations = compensations.length > 0
  const { data } = useQuery(ContractsTaxonomiesDocument, {
    variables: {
      ids: compensations.map((compensation) => compensation.attributes.contracts_taxonomy_id),
    },
  })

  const shouldShowAdditionalCompensations =
    additionalCompensationsList && isValidElement(additionalCompensationsList)

  return (
    <ContractData>
      <Box gap="s24">
        <Text size="200" weight="normal" color="grey800">
          {i18n.t('contract_versions.compensation.additional_compensations.title')}
        </Text>
        {!shouldShowAdditionalCompensations && hasCompensations ? (
          <List>
            <>
              {compensations.map((compensation) => {
                const compensationTaxonomy = data?.contracts.taxonomies.find(
                  (taxonomy) => taxonomy.id === compensation.attributes.contracts_taxonomy_id
                )
                return (
                  <CompensationItem
                    key={`compensation-${compensation.id}`}
                    compensation={compensation}
                    employee={employee}
                    taxonomy={compensationTaxonomy}
                  />
                )
              })}
            </>
          </List>
        ) : (
          additionalCompensationsList
        )}
        {!shouldShowAdditionalCompensations && !hasCompensations && (
          <Text size="300" weight="medium" color="grey600">
            {i18n.t('contract_versions.compensation.not_informed')}
          </Text>
        )}
      </Box>
    </ContractData>
  )
}

export default observer(AdditionalCompensations)
